// Compute a compact, shareable "chart signature" from a user's natal object.
// Format: #{initials}-{birthYear}-{zodiacAbbr}-{lifePath}
// Example: Selene Voss / 1993-03-05 / Pisces / life_path 3 → "#SV-1993-PS-3"

const ZODIAC_ABBR = {
  Aries: "AR", Taurus: "TA", Gemini: "GE", Cancer: "CA",
  Leo: "LE", Virgo: "VI", Libra: "LI", Scorpio: "SC",
  Sagittarius: "SG", Capricorn: "CP", Aquarius: "AQ", Pisces: "PS",
};

export function chartSignature(natal) {
  if (!natal) return null;
  const name = (natal.name || "").trim();
  const initials = name
    .split(/\s+/)
    .filter(Boolean)
    .slice(0, 2)
    .map((w) => w[0].toUpperCase())
    .join("");
  const year = (natal.birth_date || "").slice(0, 4);
  const zAbbr = ZODIAC_ABBR[natal.zodiac] || "??";
  const lp = natal.life_path ?? "?";
  if (!initials || !year) return null;
  return `#${initials}-${year}-${zAbbr}-${lp}`;
}
